import React from 'react';
import CustomSelector from '@shared/components/CustomSelector';

/**
 * @typedef {object} ViewSelectorProps
 * @property {*} [selectedView]
 * @property {(selectedView: string | number) => void} [setSelectedView]
 * @property {boolean} [disabled]
 * @property {Array<*>} [options]
 */

/**
 * @param {ViewSelectorProps} props
 */
const ViewSelector = props => {
  const { selectedView, disabled, setSelectedView, options } = props;

  return (
    <div className='dropdown-box'>
      <p className='bold'>View</p>
      <CustomSelector
        id='select-view'
        testId='select-view'
        disabled={disabled}
        options={options}
        value={selectedView}
        setValue={setSelectedView}
      />
    </div>
  );
};

export default ViewSelector;
